import { createAsyncThunk } from '@reduxjs/toolkit';

import { getSigningDocuments } from '@/api/document';

export const fetchSigningDocuments = createAsyncThunk(
  'document-signing/fetch-signing-documents',
  () => getSigningDocuments(),
);
